import ButtonMui from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';
/**
 * Estilização do componente WrapModal
 */
export const WrapModal = styled.div`
  position: fixed;
  top: 30;
  left: 0;
  width: 420px;
  height: 572px !important;
  z-index: 1650;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  .divGeral {
    margin-left: 40px;
  }
  .titleLayer {
    font-size: 16px;
    color: #5e5e5e;
    margin-bottom: 24px;
  }
  .modal {
    min-width: 401px;
    .body {
      max-width: 331px;
    }
  }

  button {
    &.close_bt {
      background: none;
      border: none;
      margin: 0 4px;
      -webkit-flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      color: #bec7dc;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
  }

  .MuiSelect-selectMenu {
    height: 22px;
    color: rgba(0, 0, 0, 0.54);
    display: flex;
    justify-content: center;
  }

  .MuiFormControl-root {
    margin: 0;
  }

  .flex-row-label {
    display: flex;
    width: 100%;
    margin-bottom: 4px;

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5e5e5e;
  }

  .flex-row {
    display: flex;
    width: 100%;
    margin-bottom: 24px;
  }

  .area-table {
    position: relative;
    width: 335px;
    height: 264px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    box-sizing: border-box;
    border-radius: 3px;
    overflow: auto;

    .loaderClassification {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.8);
      color: #5e5e5e;
      z-index: 5;
      @media (max-width: 768px) {
        height: calc(50vh - 53px);
        top: 60px;
      }
    }
  }

  .header {
    h3 {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 19px;
      color: #5e6366;
    }
  }
  .text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.6);
  }

  .loadingApplyClassification {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    color: #5e5e5e;
    z-index: 5;
    @media (max-width: 768px) {
      height: calc(50vh - 53px);
      top: 60px;
    }
  }
`;

/**
 * Estilização do componente WrapClassTable
 */
export const WrapClassTable = styled.div`
  width: 100%;
  height: 100%;

  table {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #5e5e5e;
    width: 96%;
    margin-left: 12px;
    border-collapse: separate;

    th,
    td {
      border-bottom: none;
      padding: 0px 10px;
      word-wrap: break-word;
      text-align: left;
    }

    tr th {
      height: 38px;
      background: white;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 2;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 16px;

      color: #5e5e5e;
      border-bottom: 1px solid #e5e5e5;
      /* border-collapse: separate;
     border-spacing: 0; */
      //box-sizing: border-box;
      //margin-left: auto;
    }

    tr td {
      padding-top: 10px;
      height: 28px;
    }
  }
  .hexColorPicker {
    z-index: 2000 !important;
    width: 600px;
  }
  .buttonEditSymbology {
    border: 0.1px solid gray;
    background-color: none;
    width: 30px;
    height: 22px;

    .iconBucket svg {
      display: none;
    }

    &:hover svg {
      display: none;
    }

    &:hover .iconBucket svg {
      display: block;
    }

    &:hover {
      background-color: #d2d4d3;
    }
  }

  .text-field {
    width: 100px;
    font-size: 12px;
    line-height: 16px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    letter-spacing: normal;

    &.highlightLine {
      &::before {
        border-bottom: 2px solid #f44336;
      }
    }

    &::before {
      border-bottom: 0.5px solid #5e6366;
    }

    &:hover {
      &::before {
        border-bottom: 0.5px solid #000 !important;
      }
    }

    input {
      padding: 0px 4px 4px;
    }
  }
`;

/**
 * Estilização do componente FormButtonCancel
 */
export const FormButtonCancel = styled(ButtonMui)`
  &.MuiButton-root {
    background: #aeaeae;
    border-radius: 3px;
    width: 102px;
    height: 32px;

    &:hover {
      background: #3c71dd;
    }

    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #ffffff;
      text-transform: none;
    }
  }
`;

/**
 * Estilização do componente FormButtonSave
 */
export const FormButtonSave = styled(ButtonMui)`
  &.MuiButton-root {
    background: #3c71dd;
    border-radius: 3px;
    width: 90px;
    height: 32px;
    margin-left: 16px;

    &:hover {
      background: #303f9f;
    }

    &.Mui-disabled {
      background: #aeaeae;
    }

    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #ffffff;
      text-transform: none;
    }
  }
`;

/**
 * Estilização do componente WrapConfigureLabel
 */
export const WrapConfigureLabel = styled.div`
  .MuiButton-root {
    width: 85.43px;
    height: 24px;
    padding: 4px;
    background-color: #3c71dd;
    border-radius: 3px;
    transition: opacity 300ms;
    &:disabled {
      background-color: #aeaeae;
    }
    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      text-transform: capitalize;
    }
    &:hover {
      background-color: #3c71dd;
      opacity: 0.7;
    }
  }

  .config-label-actions {
    width: 100%;
    height: 22px;
    padding: 0px 3px;
    display: none;

    &.active {
      display: flex;
      @media (max-width: 768px) {
        display: none;
      }
    }

    .config-label-action {
      background: none;
      border: none;
      text-decoration: none;
      color: #797e82;
      padding: 3px 40px 3px 0px;
      /* padding-right: 14px; */

      .select {
        position: relative;
        width: 100%;
        height: 20px;
        padding: 0px;
        color: #5e5e5e;
      }

      .a-icon {
        margin-top: 3.5px;

        &.disabled {
          path {
            fill: #b6b6b6;
          }
        }
      }

      &:hover {
        color: #3c71dd;
      }

      .disabled {
        color: #b6b6b6;
      }

      .MuiSvgIcon-fontSizeSmall {
        font-size: 1rem;
      }
    }

    .config-label-align-action {
      background: none;
      border: none;
      text-decoration: none;
      color: #797e82;
      padding: 3px 7px 0px 7px;
    }

    .save {
      padding-left: 40px;
    }
  }
`;

/**
 * Estilização do componente StyledPopupFontColor
 */
export const StyledPopupFontColor = styled(Popover)`
  z-index: 2000 !important;

  .MuiPopover-paper {
    height: 32px;
    border: 0.1px solid gray;
    border-radius: 3px;
    padding: 3px 3px;
    min-width: 25px;
    overflow-x: initial;
    overflow-y: initial;
    box-shadow: none;
    .arrow-font-color-picker {
      position: absolute;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-bottom: 11px solid gray;
      transform: rotate(-180deg);
      left: 8px;
      top: 32px;
      opacity: 1;
      transition: opacity 250ms;
    }
  }
`;

export const StyledEditAttributes = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 5px;
  font-size: 0.8rem;
  cursor: pointer;
  overflow-y: auto;

  .containerTextField {
    margin-top: 4px;
    margin-left: 4px;
  }
`;
